import { Boundaries } from "@planzone/core";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { State } from "./types";

function handleRequest(
  state: State,
  { filter }: Boundaries["retrieveNotifications"]["request"],
): State {
  return filter.start === 0
    ? {
        notifications: [],
        request: setRequestStateToPending(),
        filter: {
          ...filter,
          start: filter.start + 1,
        },
        totalPages: 0,
      }
    : {
        ...state,
        request: setRequestStateToPending(),
        filter: {
          ...filter,
          start: filter.start + 1,
        },
      };
}

export { handleRequest };
